import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Typography } from '@mui/material';
import { useState } from 'react';
import RelatorioFiscalProdutos from './RprodutosFiscalPdf';
import { NavBarRelatoriosFiscal } from '../../../shared/components/navbar/NavBarRelatoriosFiscal';
import { RelatorioFiscalService } from '../../../shared/services/api/Fiscal/ServiceRelatorioFinanceiro';

export const RelatoriosFiscalProdutos: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') return;
    setOpenmsg(false);
  };

  const handleSave = () => {
    setIsLoading(true);

    RelatorioFiscalService
      .RProdutosFiscal()
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else if (result.length > 0) {
          RelatorioFiscalProdutos(result);
        } else {
          setTms('warning');
          setMsg('Nenhum produto com estoque encontrado');
          setOpenmsg(true);
        }
      });
  };

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column">
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1} alignContent='center'></Box>
      <Box
        component={Paper}
        sx={{
          width: '100%',
          maxWidth: 600,
          margin: 'auto',
          padding: 1,
        }}
      >
        <NavBarRelatoriosFiscal />
        <DialogTitle>Relatório Fiscal de Produtos</DialogTitle>
        <DialogContent dividers>
          {isLoading && <LinearProgress variant='indeterminate' />}
          <Typography variant='body2' color='text.secondary'>
            Lista todos os produtos com estoque maior que zero, com descrição, código EAN,
            código interno, NCM, CFOP e todas as demais configurações fiscais cadastradas
            (origem, CST, CST de IPI/COFINS/PIS, alíquotas de ICMS/PIS/COFINS/IPI e código ANP).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={handleSave} disabled={isLoading}>
            Visualizar
          </Button>
        </DialogActions>
      </Box>
    </Box>
  );
};
